// ProtectedRoute.jsx
import useUser from 'hooks/useUser';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRoles, requiredPermission }) => {
  const user = useUser();
  const role = user?.role;
  const permissions = user?.permissions || {};

  // Check role
  if (!role || !allowedRoles.includes(role)) {
    return <Navigate to="/login-register" replace />;
  }

  // Check granular permission if required
  if (requiredPermission) {
    const hasPermission =
      permissions[requiredPermission] && permissions[requiredPermission] !== 'none';
    if (!hasPermission) {
      return <Navigate to="/dashboard-overview" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
